import React from 'react';
import { styled } from '@mui/system';

const DivFlexCenter = styled('div')((props) =>({
    display: 'flex',
    alignItems: 'center',
    justifyContent:'center',
}));

export default DivFlexCenter;